import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-detection-state',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './detection-state.component.html',
  styleUrl: './detection-state.component.scss'
})
export class DetectionStateComponent {
  @Input() state: string = "";
}
